import { safeLocalStorage } from '@/lib/safeStorage';
import { useNavigate } from 'react-router-dom';
import { useUserInfo } from './useUserInfo';
import { resetWebSocketClient } from './useWebSocket';
import { AUTH_EVENTS, STORAGE_KEYS } from '../lib/constants';
import { clearTokens } from '../lib/api/auth';

/**
 * Returns a logout handler that clears auth state and redirects to /login.
 * Extracted from App.tsx so the profile menu (now in the page header) can log
 * out without threading an onLogout prop through the layout.
 */
export function useLogout() {
  const navigate = useNavigate();
  const { orgId } = useUserInfo();

  return () => {
    // Clear all authentication-related localStorage data
    clearTokens();
    // The "Viewing as" marker dies with the session it described.
    safeLocalStorage.removeItem(STORAGE_KEYS.VIEW_AS);
    safeLocalStorage.setItem(STORAGE_KEYS.HAS_LOGGED_OUT, 'true');

    // Clear onboarding cache for this org
    if (orgId) {
      safeLocalStorage.removeItem(`${STORAGE_KEYS.ONBOARDING_COMPLETED}_${orgId}`);
    }

    // Disconnect WebSocket to clean up connection
    resetWebSocketClient();

    // Reset theme to light mode on logout
    safeLocalStorage.removeItem('theme');
    document.documentElement.classList.remove('dark');
    document.documentElement.classList.add('light');

    // Dispatch a custom event to signal logout to other components
    window.dispatchEvent(new Event(AUTH_EVENTS.TOKENS_UPDATED));

    navigate('/login');
  };
}
